import { render, staticRenderFns } from "./afflist2.vue?vue&type=template&id=08fb6498"
import script from "./afflist2.vue?vue&type=script&lang=js"
export * from "./afflist2.vue?vue&type=script&lang=js"
import style0 from "./afflist2.vue?vue&type=style&index=0&id=08fb6498&prod&lang=scss&scooped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports